module.exports = __webpack_public_path__ + "img/img_fuceng.066661b3.png";